import SpotifyWebApi from "spotify-web-api-js";

const spotify = new SpotifyWebApi();
export default spotify;